import i18n from 'i18nextInstance';

export const FILTER_OPTIONS = {
    patient: [
        {
            label: i18n.t('Todos'),
            value: ''
        },
        {
            label: i18n.t('Atendida'),
            value: 'Accepted'
        },
        {
            label: i18n.t('Rechazada'),
            value: 'Rejected'
        },
        {
            label: i18n.t('No atendida'),
            value: 'TimeOut'
        },
        {
            label: i18n.t('Completando evolución'),
            value: 'Evolving'
        },
        {
            label: i18n.t('Desconectada'),
            value: 'Disconnected'
        }
    ],
    professional: [
        {
            label: i18n.t('Todos'),
            value: ''
        },
        {
            label: i18n.t('Disponible'),
            value: 'Available'
        },
        {
            label: i18n.t('En sesión'),
            value: 'Busy'
        },
        {
            label: i18n.t('No Disponible'),
            value: 'Unavailable'
        }
    ]
};
